import { render } from "./LinkDetailV2.vue?vue&type=template&id=e1180ace&scoped=true&ts=true"
import script from "./LinkDetailV2.vue?vue&type=script&lang=ts"
export * from "./LinkDetailV2.vue?vue&type=script&lang=ts"

import "./LinkDetailV2.vue?vue&type=style&index=0&id=e1180ace&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1180ace"]])

export default __exports__